import { render, staticRenderFns } from "./Addons.vue?vue&type=template&id=4d79bb3e"
import script from "./Addons.vue?vue&type=script&lang=js"
export * from "./Addons.vue?vue&type=script&lang=js"
import style0 from "./Addons.vue?vue&type=style&index=0&id=4d79bb3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports